import { COLOR } from "../../../../common/Color"
import { FontType } from "../../../../common/TextUtils"
import { Buttons } from "../../../generic-sprites/Buttons"
import { PhaserText } from "../../../utils/PhaserText"
import { Sprites } from "../../../utils/Sprites"
import { CigTourParts } from "../cig-tour/CigTourTypes"

export class TobaccoTourCigPart {
    sprite: Phaser.Sprite
    text: Phaser.Text

    constructor(
        game: Phaser.Game,
        group: Phaser.Group,
        public cigPart: CigTourParts,
        image: string,
        spriteX: number,
        spriteY: number,
        label: string,
        labelX: number,
        labelY: number,
        onClick: () => void,
    ) {
        this.sprite = Sprites.add(game, image, {
            x: spriteX,
            y: spriteY,
            group,
        })
        this.text = PhaserText.create(game, label, {
            x: labelX,
            y: labelY,
            group,
            type: FontType.FUTURISTIC,
        })

        this.sprite.animations.add(cigPart, [0, 1, 2, 3, 4, 5])

        Buttons.makeSpriteButton(this.sprite, onClick)
    }

    open = () => this.sprite.animations.play(this.cigPart, 15, false)

    setPartClicked = () => (this.text.fill = COLOR.gray)

    getPartAsset = (audio = false): string =>
        `cig-tour-${this.cigPart}-${audio ? "audio.mp3" : "video.mp4"}`
}
